export default ( paymentSummary ) => {
  const cardType = paymentSummary.cardType;
  let detailProfile = '';

  switch (paymentSummary.cardType) {
    case 'AMEX':
      detailProfile = 'CC Cobranded';
      break;

    case 'UATP':
      break;

    case 'VISA_CHECKOUT':
      break;

    case 'MASTERPASS':
      detailProfile = cardType;
      break;

    case 'MASTER':
      break;

    case 'VISA':
      detailProfile = `CC ${( paymentSummary.bankName ) ?  paymentSummary.bankName : cardType }`;
      break;

    case 'CREDIT_CARD':
      detailProfile = `CC - ${ paymentSummary.bankName }`;
      break;
  }

  const object = {
    'event': 'profileInfo',
    'actionType': 'Use',
    'profileField': `Profile - ${ cardType }`,
    'detailProfile': ( paymentSummary.errorMsg ) ? `${detailProfile} - Unsuccesful Payment` : detailProfile,
  };

  if ( paymentSummary.errorMsg ) {
    object.errorMsg = paymentSummary.errorMsg;
  }

  return object;
};
